// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Users_establishments__2vgvr","header":"Users_header__GpZmw","tableHeader":"Users_tableHeader__38VW4"};